import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DownloadSimple, Desktop } from "@phosphor-icons/react";

export default function InstallButton() {
  const [promptEvent, setPromptEvent] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (isStandalone) setInstalled(true);

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setPromptEvent(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setPromptEvent(null);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !promptEvent) return null;

  return (
    <Button
      data-testid="install-app-button"
      onClick={async () => {
        try {
          await promptEvent.prompt();
          await promptEvent.userChoice;
          setPromptEvent(null);
        } catch {
          setPromptEvent(null);
        }
      }}
      variant="outline"
      className="hidden md:inline-flex rounded-none border-neutral-900 hover:bg-neutral-100 gap-2 h-9"
      title="Install Import Export Price Calculator as a desktop app"
    >
      <Desktop size={16} weight="bold" />
      <span>Install app</span>
    </Button>
  );
}
